<div class="panel-content-inner">
    <ng-content></ng-content>
</div>
